import { Progress } from "antd";
import { useTranslation } from "react-i18next";
import Recommendation from "containers/recommendation";

const RiskQuestions = ({
  backLoading,
  data,
  disabled,
  formRef,
  nextLoading,
  onSubmitPreviousQuestion,
  onFinishSubmitAnswer,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="p-5">
        <Progress
          className="risk-progress"
          percent={100 / data?.total_questions_count * data?.question?.priority}
          format={() => (
            <span className="body-14px-regular text-gray-0">
              {data?.question?.priority}/{data?.total_questions_count}
            </span>
          )}
          type="line"
        />
        <Recommendation
          backLoading={backLoading}
          btnClassName={"!-mr-5"}
          data={data}
          disabled={disabled}
          formRef={formRef}
          isShowBackBtn={data?.question?.priority > 1}
          isFinalQuestion={
            data?.question?.priority === data?.total_questions_count
          }
          nextLoading={nextLoading}
          onBack={onSubmitPreviousQuestion}
          onFinish={onFinishSubmitAnswer}
        />
      </div>
    </>
  );
};

export default RiskQuestions;
